import {
    SET_PAYPAL_CURRENCY_START,
    SET_PAYPAL_CURRENCY_SUCCESS,
    SET_PAYPAL_CURRENCY_ERROR
} from '../../constants';
import { updatePaypalCurrency as mutation } from '../../lib/graphql';

export function updatePaypalCurrency({ currency }) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({ type: SET_PAYPAL_CURRENCY_START });

            const { data } = await client.mutate({
                mutation,
                variables: { currency }
            });
            if (data) {
                dispatch({ type: SET_PAYPAL_CURRENCY_SUCCESS });
            }

        } catch (error) {
            dispatch({ type: SET_PAYPAL_CURRENCY_ERROR });
        }
        return {
            status: '200'
        };
    };
}